/* eslint-disable react-hooks/exhaustive-deps */
import { Grid } from "@mui/material";
import { FC, Fragment, useState } from "react";
import { useFormik } from "formik";
import InputTextfield from "../../../../../shared/components/textField";
import { customizeValidationSchema } from "./variable/customSchema";
import { getTwoFactorAuthenticationFields } from "../variable/textField";
import OtpForm from "./otpForm";
import useMutation from "../../../../../shared/components/hooks/useMutation";
import { FormProfileContainer } from "../../../../../shared/components/formProfileContainer";
// import { FormProfileContainer } from "../../../../../shared/components/formProfileContainer";

type TwoFactorAuthenticationProps = {
  setVerficationStatus: Function;
  twoFactorAuthFlag: boolean;
  fetchData: Function;
  userEmail: string;
};

const TwoFactorAuthentication: FC<TwoFactorAuthenticationProps> = ({
  setVerficationStatus,
  twoFactorAuthFlag,
  fetchData,
  userEmail,
}) => {
  const { loading: apiLoading, modifyData } = useMutation();
  const [otpForm, setOtpForm] = useState<boolean>(false);
  const textFields = getTwoFactorAuthenticationFields({}); //Get textboxes
  const initialValues = {
    secretKey: "",
  };

  const secretPinForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnBlur: true,
    validationSchema: customizeValidationSchema(),

    onSubmit: async (formData: any) => {
      let response = await modifyData(
        `admin/two-factor-auth`,
        "put",
        {
          ...formData,
        },
        secretPinForm
      );
      if (response) setOtpForm(true);
    },
  });

  const titleBar = {
    headerTitle: "",
    title: "",
    buttonTitle: "Next",
    onClick: () => secretPinForm.handleSubmit(),
    dirty: secretPinForm.dirty,
    buttonLoading: apiLoading,
  };

  return (
    <>
      {" "}
      {!otpForm && (
        <FormProfileContainer titleBar={titleBar}>
          <Grid container alignItems="stretch" columnSpacing={4} rowSpacing={2}>
            <Grid item md={12} sm={6} xs={12}>
              We'll send a verification code to this email address whenever you
              sign in to your account:
            </Grid>
            {textFields.map((field: any, index: number) => (
              <Fragment key={field.id}>
                {(field?.formField === undefined ||
                  field.formField === true) && (
                  <Grid item md={6} sm={6} xs={12}>
                    <InputTextfield
                      form={secretPinForm}
                      fieldProps={field}
                      key={index}
                    />
                  </Grid>
                )}
              </Fragment>
            ))}
          </Grid>
        </FormProfileContainer>
      )}
      {otpForm && (
        <OtpForm
          setVerficationStatus={setVerficationStatus}
          twoFactorAuthFlag={twoFactorAuthFlag}
          fetchData={fetchData}
          userEmail={userEmail}
        />
      )}
    </>
  );
};
export default TwoFactorAuthentication;
